
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import OpenButton from '../common/OpenButton';

const SelectPricelistFromFile = ({
    acceptFileType,
    onUploadFile
}) => {

    return (
        <Stack>
            <h3>Zadání souboru s ceníkem materiálu a prací</h3>
            <Stack.Item>
                <OpenButton
                    acceptFileType={acceptFileType}
                    onProcessOpenFile={onUploadFile}
                    text="Načíst soubor s ceníkem materiálu a prací"
                />
            </Stack.Item>
        </Stack>
    );
}

export default SelectPricelistFromFile;
